<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.BAGS' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		
		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
		</app-included-per-passenger>
		
		<div class="sidebar-flight-text">
			<p>
				{{ 'whatsIncludedSidebars.detailsLuggage.texts.milesAndGoInfo' | ibeadmin: 'sync' }}
			</p>
			<p>
				{{ 'whatsIncludedSidebars.detailsLuggage.texts.visaGoldPlatinumInfo' | ibeadmin: 'sync' }}
			</p>
			<a 
				(click)="INDRA_gotoURL('externalURLs.aboutCheckedBagsMilesGoPerks')" 
				class="link extras-feature__link link--external" 
				aria-label="Open new window">
				{{ 'whatsIncludedSidebars.detailsLuggage.texts.learnAbout' | ibeadmin: 'sync' }}
			</a>
		</div>

		<div class="sidebar-flight-text">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsLuggage.titles.rules' | ibeadmin: 'sync' }}
			</h2>
			<div class="border sidebar-flight-text no-padding-top">
				<h4 class="bold">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.maxWeight' | ibeadmin: 'sync' }}
				</h4>
				<p class="">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.checkedBaggageWeight' | ibeadmin: 'sync' }}: 
					{{ maxBagWeightAllowance }} 
				</p>
				<p *ngIf="hasInfantPassenger" class="">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.babyAllowance' | ibeadmin: 'sync' }}: 
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.babyAllowanceSpec' | ibeadmin: 'sync' }}
				</p>
			</div>
			<div class="sidebar-flight-text ">
				<h4 class="bold">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.maxDimension' | ibeadmin: 'sync' }}
				</h4>
				<p class="max-descrip">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.maxDimensionSpecs' | ibeadmin: 'sync' }} 
					<span *ngIf="hasInfantPassenger">{{ 'whatsIncludedSidebars.detailsLuggage.texts.maxDimensionSpecsBaby' | ibeadmin: 'sync' }}</span>
				</p>

				<app-notification *ngIf="isUSA" [style]="'information'" [classes]="'alert-sidebar'"
					[title]="'whatsIncludedSidebars.detailsLuggage.titles.restrictions' | ibeadmin: 'sync'">
					<div message>
						{{ 'whatsIncludedSidebars.detailsLuggage.texts.restrictions' | ibeadmin: 'sync' }}
					</div>
				</app-notification>

				<a 
					(click)="INDRA_gotoURL('externalURLs.aboutBaggageRules')"
					href="javascript:;"
					class="link link--external"
					aria-label="Open check all hand baggage rules and restrictions, opens new window">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.allRulesRestrictions' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>

		<app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>
		
		<div class="sidebar-flight-text" 
			*ngIf="reviewFlights && brand !== 'star_alliance-economy' && brand !==  'star_alliance-first' && brand !== 'star_alliance-business' && showAddButton">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsLuggage.titles.extraBaggage' | ibeadmin: 'sync' }}
			</h2>
			<p class="muted">
				{{ 'whatsIncludedSidebars.detailsLuggage.texts.extraBaggage' | ibeadmin: 'sync' }}
			</p>
			<button class="button " (click)="openExtraBagsSidebar()" aria-label="Open a dialog to add extra bags.">
				{{ 'whatsIncludedSidebars.detailsLuggage.button.addExtraBags' | ibeadmin: 'sync' }}
			</button>
		</div>
		
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog"
					(click)="INDRA_handleClose()" 
					href="javascript:;" 
					role="button">
					{{ 'whatsIncludedSidebars.detailsLuggage.texts.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>

</div>
